"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.wrapper)
    }, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(["underground-token-background", _ctx.style + ' ' + _ctx.border])
        }, null, 2),
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(_ctx.style + ' ' + _ctx.tokenClass)
        }, null, 2),
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(_ctx.shelter)
        }, null, 2)
    ], 2));
}
